
import { useNavigate } from "react-router-dom"
import { useParams } from 'react-router-dom';

import { useDispatch } from "react-redux";
import { visualizerActions } from '../../store';

import { loadShareLink } from "../../Helpers/ShareHelper";

export default function LoadingPage(){

    const urlParams = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    if(urlParams.code === "UPLOAD"){
        dispatch(visualizerActions.loadBackup(JSON.parse(localStorage.getItem("VIZ_BACKUP"))))


        var uploadImages = JSON.parse(localStorage.getItem("UPLOAD_SPECS"));

        if(uploadImages === null) uploadImages = [];

        if(uploadImages.indexOf(encodeURIComponent(urlParams.spec)) === -1){
            uploadImages.push(encodeURIComponent(urlParams.spec));
        }

        localStorage.setItem("UPLOAD_SPECS",JSON.stringify(uploadImages));
        

        setTimeout(() => {
        navigate(`/roomview/${encodeURIComponent(urlParams.spec)}`);
        }, 1000);
    }
    else{
        loadShareLink(urlParams.code).then(data => {
            const shareData = JSON.parse(data.data1);
    
            dispatch(visualizerActions.loadBackup(shareData.backup));
    
            navigate(`/visualizer`);
        })
    }

    // useEffect(() => {
        
        

    // }, []);

    return (
    <section>
        Redirecting...
    </section>);
}